import { create } from 'zustand';
/**
 * Holds the access token in memory only.
 *
 * It is deliberately not persisted. Any script running on the page can read browser
 * storage, so a token kept there is exfiltrable by an XSS and - worse - keeps working
 * afterwards, re-granting itself on every page load. In memory it dies with the tab, which
 * narrows a theft to the lifetime of the token rather than the lifetime of the session.
 *
 * What survives a reload instead is the refresh token, which lives in an httpOnly cookie
 * the page cannot read at all. `restoreSession` trades it for a fresh access token during
 * boot, so a hard refresh costs one round trip rather than a sign-in. That round trip is
 * what makes not persisting this affordable; see `restoreSession` in the api folder.
 */
export const useAuthStore = create((set) => ({
    authToken: null,
    authType: null,
    isTokenRefreshing: false,
    updateAuthToken: (token, authType) => {
        set({ authToken: token, authType });
    },
    removeAuthToken: () => {
        set({ authToken: null, authType: null });
    },
    setIsTokenRefreshing: (isRefreshing) => {
        set({ isTokenRefreshing: isRefreshing });
    },
}));
